'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import FlowWaypoints from '../fx/FlowWaypoints'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--services'
        // Fns
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        this.waypoints.destroy()
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            this.waypoints = new FlowWaypoints(this.view)
        }, 200);
    }

    intro()
    {
        const tl = new TimelineLite()
        const $title = this.view.querySelector('.services-splashscreen .h2')
        const $bg = this.view.querySelector('.services-splashscreen .bg')
        const $line = this.view.querySelector('.services-splashscreen .line-scroll')
        const $cellLeft = this.view.querySelector('.services-brand .cell:nth-child(1)')
        // const $cellRight = this.view.querySelector('.services-brand .cell:nth-child(2)')

        tl.add([
            TweenLite.fromTo($bg , .8 , { opacity : 0 } , { opacity : 1 , ease : Power4.easeOut }),
            TweenLite.fromTo($line , .8 , { opacity : 0 } , { opacity : .5 , ease : Power4.easeOut , delay : .4 }),
            TweenLite.fromTo($title , .8 , { opacity : 0 , y : 30 } , { opacity : 1, y : 0 , ease : Power4.easeOut }),
            TweenLite.fromTo($cellLeft , .8 , { opacity : 0 , y : 30 } , { opacity : 1, y : 0 , ease : Power4.easeOut , delay : .2 }),
        ])
    }
}

page = Barba.BaseView.extend({
    namespace: 'services',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/services.js